<template>
  <div class="process-configuration">
    <!-- Header -->
    <div class="header-section">
      <div class="header-content">
        <div class="header-text">
          <h2 class="title is-4">Configuración del Proceso</h2>
          <p class="subtitle is-6 has-text-grey">
            Personaliza los parámetros y configuración del proceso
          </p>
        </div>
        <div class="header-actions">
          <b-tag v-if="hasChanges" type="is-warning" class="mr-2">
            Cambios pendientes
          </b-tag>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="columns">
      <!-- Sidebar Navigation -->
      <div class="column is-3">
        <div class="sidebar-nav">
          <div
            v-for="section in sections"
            :key="section.id"
            :class="['nav-item', { 'is-active': activeSection === section.id }]"
            @click="activeSection = section.id"
          >
            <div class="nav-item-content">
              <b-icon :icon="section.icon" />
              <div class="nav-item-text">
                <div class="nav-item-title">{{ section.title }}</div>
                <div class="nav-item-description">
                  {{ section.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="column is-9">
        <div class="config-card">
          <!-- General Configuration -->
          <div v-if="activeSection === 'general'" class="config-section">
            <process :hasChanges="hasChanges" @handleChange="handleChange" />
          </div>

          <!-- Dependencies Configuration -->
          <div v-if="activeSection === 'dependencies'" class="config-section">
            <dependencies />
          </div>

          <!-- Upload Configuration -->
          <div v-if="activeSection === 'upload'" class="config-section">
            <upload-collaborators />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dependencies from "../configuration/Dependencies.vue";
import Process from "../configuration/Process.vue";
import UploadCollaborators from "../configuration/UploadCollaborators.vue";

export default {
  name: "ProcessConfiguration",
  components: {
    Process,
    UploadCollaborators,
    Dependencies,
  },
  data() {
    return {
      activeSection: "general",
      hasChanges: false,
      sections: [
        {
          id: "general",
          title: "Configuración General",
          description: "Datos básicos del proceso",
          icon: "cog",
        },
        {
          id: "dependencies",
          title: "Dependencias",
          description: "Campos dinámicos para colaboradores",
          icon: "file-tree-outline",
        },
        {
          id: "upload",
          title: "Carga de Colaboradores",
          description: "Importar datos desde Excel",
          icon: "upload",
        },
      ],
    };
  },
  methods: {
    handleChange(value = true) {
      this.hasChanges = value;
    },
  },
};
</script>

<style scoped>
.process-configuration {
  padding: 1rem;
}

/* Header */
.header-section {
  margin-bottom: 2rem;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}

.header-actions {
  display: flex;
  margin-top: 1rem;
  align-items: center;
  gap: 0.5rem;
}

/* Sidebar Navigation */
.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.nav-item {
  padding: 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white;
  border: 1px solid transparent;
}

.nav-item:hover {
  background-color: #f5f5f5;
}

.nav-item.is-active {
  background-color: #131313;
  color: white;
  border-color: #131313;
}

.nav-item-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.nav-item-text {
  flex: 1;
}

.nav-item-title {
  font-weight: 500;
  font-size: 0.875rem;
  margin-bottom: 0.125rem;
}

.nav-item-description {
  font-size: 0.75rem;
  opacity: 0.75;
}

/* Config Card */
.config-card {
  background-color: white;
  border: 1px solid #dbdbdb;
  border-radius: 6px;
  padding: 1.5rem;
}

.config-section > div {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Responsive */
@media screen and (max-width: 1023px) {
  .header-content {
    flex-direction: column;
  }

  .header-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .sidebar-nav {
    flex-direction: row;
    overflow-x: auto;
  }

  .nav-item {
    min-width: 200px;
  }

  .template-content {
    flex-direction: column;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/process/Configuration.vue